import { useQuery } from '@hooks/core';
import api from './api';

export const useFormInitial = (id: number) => useQuery(() => api.getBalanceDetails(id));

export const useUnits = () => useQuery(api.getUnits, { initial: [] });
